import React from 'react';

const Preview = () => {
  return (
    <div className="flex items-center justify-center min-h-[70vh] bg-gray-50">
      <div className="bg-white shadow-lg rounded-lg p-6 sm:p-10 w-full max-w-3xl border-t-4 border-orange-500">
        <div className="text-center">
          <h2 className="text-xl sm:text-2xl font-semibold text-green-700 mb-4">
            Your Refund Claim has been Successfully Submitted!
          </h2>

          <p className="text-gray-700 text-base sm:text-lg">
            Your refund will be credited to your bank account within  next
            <span className="font-medium text-orange-600"> 7-30 working days</span>.
          </p>

          {/* Optional notice for refund batch window */}
          {/* 
          <p className="text-sm text-gray-600 mt-4">
            Refund of seat confirmation fee will be settled between 
            <span className="font-semibold"> 7th Aug to 15th Aug</span>. (Approx amount: ₹20,000)
          </p> 
          */}

          <div className="mt-6">
            <button
              type="button"
              className="bg-[#042e2e] hover:bg-[#024141] text-white px-6 py-2 rounded-md text-sm shadow"
            >
              Thank You
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Preview;
